import React from 'react';
import { Phone, Globe } from 'lucide-react';

const ContactButtons: React.FC = () => {
  return (
    <div className="fixed bottom-8 right-4 z-50 flex flex-col gap-2">
      <a 
        href="https://zalo.me/2043300997419459145" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors"
        title="Liên Hệ Zalo"
      >
        <span className="font-bold">Zalo</span>
      </a>
      
      <a 
        href="https://m.me/VMonCloud" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors"
        title="Messenger"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          <path d="M12 2.04C6.5 2.04 2 6.13 2 11.22C2 14.38 3.57 17.12 6.02 18.74V22.95L10.15 20.51C10.74 20.64 11.36 20.71 12 20.71C17.5 20.71 22 16.61 22 11.53C22.01 6.44 17.5 2.04 12 2.04ZM13.84 14.7L10.92 11.67L5.31 14.7L11.55 8.04L14.47 11.08L20.08 8.04L13.84 14.7Z"/>
        </svg>
      </a>
      
      <a 
        href="tel:+84966805315" 
        className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors"
        title="Phone"
      >
        <Phone size={20} />
      </a>
      
      <a 
        href="/docs" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors"
        title="Help Center"
      >
        <Globe size={20} />
      </a>
    </div>
  );
};

export default ContactButtons;